module.exports = {
  ConfigData: () => {
    return {
      //Bullets
      "soloModel": "Solo_Cubiertas_v7.glb",
      "bulletTexture": "./Textures/Bullet.png",
      "bulletSize": {"height": 0.2, "width": 0.2},
      "bulletAnimationScale": {"min": 0.7, "max": 1},
      "bullettarget" : {"x": 0.0, "y": 0.2, "z": 0.0},
      "bulletstartingcoords" : {"alpha": -60, "beta": 70, "radius": 20},
      "bulletCameraFOV" : 10,
      "portraitBulletCameraFOV" : 15,
      "portraitAnimationCameraFOV" : 4,
      "bulletlimitradius": {"lower": 3, "upper": 20},
      "bulletlimitbeta": {"lower": 0, "upper": 180},
      "hotspotSize": {"height": 1, "width": 1},
      
      //Lights
      "lightIntensityScene" : 0.0,
      "lightIntensitySoloView" : 0.0,

      //Environment
      "environmentIntensity" : 0.5,
      "environmentIntensitySolo" : 0.75,

      //post processing
      "contrast" : 1.2,
      "exposure" : 1.4,
      "contrastSolo" : 1.0,
      "exposureSolo" : 1.0,
    
    }
  }
}